import { AcknowledgementState } from 'utils/api/modules/entities/entities.types';

export const ACK_STATE_LABELS: Record<AcknowledgementState, string> = {
  [AcknowledgementState.Pending]: 'Pending',
  [AcknowledgementState.Acknowledged]: 'Acknowledged',
  [AcknowledgementState.Cancelled]: 'Cancelled',
};
